import { useL10n } from '@uplift/hooks';
import { useActiveSinkId } from '../../../hooks';
import { usePreVideoStyles } from '../../pre-video-call.styles';
import { MediaSetupProps } from './media-setup.props';
import { Box, Typography } from '@mui/material';
import { MediaDeviceTypes } from '@uplift/types';
import { IconWithText, MobileDropdown, MobileSection } from '@uplift/ui-v2';
import { LocalVideoPreview } from '../../../components';
import { MicOutlined, VideocamOutlined, VolumeUpOutlined } from '@mui/icons-material';
import { MEDIA_DEFAULT_OPTION } from './media-setup.component';


export const MediaSetupMobile: React.VFC<MediaSetupProps> = ({
  audioInputOptions,
  audioOutputOptions,
  videoInputOptions,
  localAudioInputDeviceId,
  localVideoInputDeviceId,
  name,
  startTime,
  replaceAudioInputTrack,
  replaceLocalVideoTrack
}) => {
  const l10n = useL10n();
  const { classes } = usePreVideoStyles();
  const { activeSinkId, setActiveSinkId } = useActiveSinkId();

  return (
    <Box height="100%">
      <LocalVideoPreview identity={l10n.sessions.you} />
      <MobileSection>
        <Box py={2}>
          <Typography variant="h5" className={classes.username}>
            {name.first} at {startTime}
          </Typography>
        </Box>
      </MobileSection>
      <MobileSection
        divider
        label={(
          <IconWithText icon={<MicOutlined className={classes.outlineButton} />}>
            {l10n.sessions.microphone}
          </IconWithText>
        )}
      >
        <MobileDropdown
          raw
          name={MediaDeviceTypes.audioInput}
          items={audioInputOptions}
          value={localAudioInputDeviceId || MEDIA_DEFAULT_OPTION.value}
          onChange={e => replaceAudioInputTrack(e.target.value)}
        />
      </MobileSection>
      <MobileSection
        divider
        label={(
          <IconWithText icon={<VolumeUpOutlined className={classes.outlineButton} />}>
            {l10n.sessions.speaker}
          </IconWithText>
        )}
      >
        <MobileDropdown
          raw
          name={MediaDeviceTypes.audioOutput}
          items={audioOutputOptions}
          onChange={e => setActiveSinkId(e.target.value)}
          value={activeSinkId || MEDIA_DEFAULT_OPTION.value}
        />
      </MobileSection>
      <MobileSection
        divider
        bottomDivider
        label={(
          <IconWithText icon={<VideocamOutlined className={classes.outlineButton} />}>
            {l10n.sessions.camera}
          </IconWithText>
        )}
      >
        <MobileDropdown
          raw
          name={MediaDeviceTypes.videoInput}
          items={videoInputOptions}
          value={localVideoInputDeviceId || MEDIA_DEFAULT_OPTION.value}
          onChange={e => replaceLocalVideoTrack(e.target.value)}
        />
      </MobileSection>
    </Box>
  );
};
